import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoElement'];

  connectedCallback() {
    super.connectedCallback();

    // We rely on native autoplay, muted, and playsinline attributes.
    // Calling .load() and .play() asynchronously can cause iOS to block playback.
    // The video element will natively autoplay as soon as the DOM loads.
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
